export default {
  methods: {
    shuffleArray: function (array) {
      return Array.from(array).sort(() => Math.random() - 0.5)
    }
  }
}
